const APP_NAME = `pds2.add-in.${process.env.NODE_ENV}`
const USER_DATA_KEY = `${APP_NAME}.userData`
const LOCALE_KEY = `${APP_NAME}.locale`
const PAGE_KEY = `${APP_NAME}.page`
const PROJECT_RECENT_KEY = `${APP_NAME}.project.recent`
const PROJECT_FAVORITES_KEY = `${APP_NAME}.project.favorites`
const PROJECT_ACTIVE_KEY = `${APP_NAME}.project.active`
const PROJECT_LIMIT_KEY = `${APP_NAME}.project.limit`
const CONTACT_RECENT_KEY = `${APP_NAME}.contact.recent`
const CONTACT_FAVORITES_KEY = `${APP_NAME}.contact.favorites`
const CONTACT_ACTIVE_KEY = `${APP_NAME}.contact.active`
const CONTACT_LIMIT_KEY = `${APP_NAME}.contact.limit`
const DEPARTMENT_RECENT_KEY = `${APP_NAME}.department.recent`
const DEPARTMENT_FAVORITES_KEY = `${APP_NAME}.department.favorites`
const DEPARTMENT_ACTIVE_KEY = `${APP_NAME}.department.active`
const DEPARTMENT_LIMIT_KEY = `${APP_NAME}.department.limit`
const FIXED_PAGE_LIMIT = 25

const toBoolean = (str) => str === 'true'

const storage = {
  // user data
  getUserData () {
    return {
      // From pds-api
      email: localStorage.getItem(`${USER_DATA_KEY}.email`),
      name: localStorage.getItem(`${USER_DATA_KEY}.name`),
      address: localStorage.getItem(`${USER_DATA_KEY}.address`),
      postal_code: localStorage.getItem(`${USER_DATA_KEY}.postal_code`),
      city: localStorage.getItem(`${USER_DATA_KEY}.city`),
      homepage: localStorage.getItem(`${USER_DATA_KEY}.homepage`),
      phone: localStorage.getItem(`${USER_DATA_KEY}.phone`),

      permissions: localStorage.getItem(`${USER_DATA_KEY}.permissions`),
      sc_root: localStorage.getItem(`${USER_DATA_KEY}.sc_root`),
      tenant_name: localStorage.getItem(`${USER_DATA_KEY}.tenant_name`),
      alternative_token_issuer: localStorage.getItem(`${USER_DATA_KEY}.alternative_token_issuer`) || null,
      templateManagerUrl: localStorage.getItem(`${USER_DATA_KEY}.templateManagerUrl`),
      sharePointSaveEnabled: toBoolean(localStorage.getItem(`${USER_DATA_KEY}.sharePointSaveEnabled`)),
      sharePointTemplatesEnabled: toBoolean(localStorage.getItem(`${USER_DATA_KEY}.sharePointTemplatesEnabled`)),

      // PDS api token
      token: sessionStorage.getItem(`${USER_DATA_KEY}.token`) || ''
    }
  },
  putUserData (userData) {
    localStorage.setItem(`${USER_DATA_KEY}.email`, userData.email)
    localStorage.setItem(`${USER_DATA_KEY}.name`, userData.name)
    localStorage.setItem(`${USER_DATA_KEY}.address`, userData.address)
    localStorage.setItem(`${USER_DATA_KEY}.postal_code`, userData.postal_code)
    localStorage.setItem(`${USER_DATA_KEY}.city`, userData.city)
    localStorage.setItem(`${USER_DATA_KEY}.homepage`, userData.homepage)
    localStorage.setItem(`${USER_DATA_KEY}.phone`, userData.phone)

    localStorage.setItem(`${USER_DATA_KEY}.permissions`, userData.permissions)
    localStorage.setItem(`${USER_DATA_KEY}.sc_root`, userData.sc_root)
    localStorage.setItem(`${USER_DATA_KEY}.tenant_name`, userData.tenant_name)
    localStorage.setItem(`${USER_DATA_KEY}.alternative_token_issuer`, userData.alternative_token_issuer || '')
    localStorage.setItem(`${USER_DATA_KEY}.templateManagerUrl`, userData.templateManagerUrl || '')
    localStorage.setItem(`${USER_DATA_KEY}.sharePointSaveEnabled`, userData.sharePointSaveEnabled)
    localStorage.setItem(`${USER_DATA_KEY}.sharePointTemplatesEnabled`, userData.sharePointTemplatesEnabled)

    sessionStorage.setItem(`${USER_DATA_KEY}.token`, userData.token)
  },
  deleteUserData () {
    localStorage.removeItem(`${USER_DATA_KEY}.email`)
    localStorage.removeItem(`${USER_DATA_KEY}.name`)
    localStorage.removeItem(`${USER_DATA_KEY}.address`)
    localStorage.removeItem(`${USER_DATA_KEY}.postal_code`)
    localStorage.removeItem(`${USER_DATA_KEY}.city`)
    localStorage.removeItem(`${USER_DATA_KEY}.homepage`)
    localStorage.removeItem(`${USER_DATA_KEY}.phone`)

    localStorage.removeItem(`${USER_DATA_KEY}.permissions`)
    localStorage.removeItem(`${USER_DATA_KEY}.sc_root`)
    localStorage.removeItem(`${USER_DATA_KEY}.tenant_name`)
    localStorage.removeItem(`${USER_DATA_KEY}.alternative_token_issuer`)
    localStorage.removeItem(`${USER_DATA_KEY}.templateManagerUrl`)
    localStorage.removeItem(`${USER_DATA_KEY}.sharePointSaveEnabled`)
    localStorage.removeItem(`${USER_DATA_KEY}.sharePointTemplatesEnabled`)

    sessionStorage.removeItem(`${USER_DATA_KEY}.token`)
  },
  deleteApiToken () {
    sessionStorage.removeItem(`${USER_DATA_KEY}.token`)
  },

  // locale
  getLocale () {
    return localStorage.getItem(LOCALE_KEY)
  },
  putLocale (locale) {
    localStorage.setItem(LOCALE_KEY, locale)
  },

  // page
  getPage () {
    return localStorage.getItem(PAGE_KEY) || 'contact'
  },
  putPage (page) {
    localStorage.setItem(PAGE_KEY, page)
  },

  // Contact settings

  getContactRecent () {
    return Boolean(JSON.parse(localStorage.getItem(CONTACT_RECENT_KEY)))
  },
  putContactRecent (show) {
    localStorage.setItem(CONTACT_RECENT_KEY, JSON.stringify(show))
  },
  getContactFavorites () {
    return Boolean(JSON.parse(localStorage.getItem(CONTACT_FAVORITES_KEY)))
  },
  putContactFavorites (show) {
    localStorage.setItem(CONTACT_FAVORITES_KEY, JSON.stringify(show))
  },
  getContactActive () {
    return Boolean(JSON.parse(localStorage.getItem(CONTACT_ACTIVE_KEY)))
  },
  putContactActive (show) {
    localStorage.setItem(CONTACT_ACTIVE_KEY, JSON.stringify(show))
  },
  getContactLimit () {
    return FIXED_PAGE_LIMIT
  },
  putContactLimit () {
    localStorage.setItem(CONTACT_LIMIT_KEY, String(FIXED_PAGE_LIMIT))
  },

  // Project settings

  getProjectRecent () {
    return Boolean(JSON.parse(localStorage.getItem(PROJECT_RECENT_KEY)))
  },
  putProjectRecent (show) {
    localStorage.setItem(PROJECT_RECENT_KEY, JSON.stringify(show))
  },
  getProjectFavorites () {
    return Boolean(JSON.parse(localStorage.getItem(PROJECT_FAVORITES_KEY)))
  },
  putProjectFavorites (show) {
    localStorage.setItem(PROJECT_FAVORITES_KEY, JSON.stringify(show))
  },
  getProjectActive () {
    return Boolean(JSON.parse(localStorage.getItem(PROJECT_ACTIVE_KEY)))
  },
  putProjectActive (show) {
    localStorage.setItem(PROJECT_ACTIVE_KEY, JSON.stringify(show))
  },
  getProjectLimit () {
    return FIXED_PAGE_LIMIT
  },
  putProjectLimit () {
    localStorage.setItem(PROJECT_LIMIT_KEY, String(FIXED_PAGE_LIMIT))
  },

  // Department settings

  getDepartmentRecent () {
    return Boolean(JSON.parse(localStorage.getItem(DEPARTMENT_RECENT_KEY)))
  },
  putDepartmentRecent (show) {
    localStorage.setItem(DEPARTMENT_RECENT_KEY, JSON.stringify(show))
  },
  getDepartmentFavorites () {
    return Boolean(JSON.parse(localStorage.getItem(DEPARTMENT_FAVORITES_KEY)))
  },
  putDepartmentFavorites (show) {
    localStorage.setItem(DEPARTMENT_FAVORITES_KEY, JSON.stringify(show))
  },
  getDepartmentActive () {
    return Boolean(JSON.parse(localStorage.getItem(DEPARTMENT_ACTIVE_KEY)))
  },
  putDepartmentActive (show) {
    localStorage.setItem(DEPARTMENT_ACTIVE_KEY, JSON.stringify(show))
  },
  getDepartmentLimit () {
    return FIXED_PAGE_LIMIT
  },
  putDepartmentLimit () {
    localStorage.setItem(DEPARTMENT_LIMIT_KEY, String(FIXED_PAGE_LIMIT))
  }
}

export default storage
